import { eventLogger } from '../../eventLogger';
import { adLogger } from '../../eventLogger/adLogger/adLogger.web';
import type { LogAnalyticsEventParams } from './types';

export const logAnalyticsEvent = ({
  ably_only_log = {},
  name,
  channel = ['firebase', 'amplitude', 'ablylog', 'facebook'],
  ...restParams
}: LogAnalyticsEventParams) => {
  if (channel.includes('ad')) {
    adLogger.log({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      analytics: restParams.analytics as any,
    });

    // Ad 채널만 있으면 Ad 로그만 전송함
    // 다른 채널이 있으면 나머지 채널도 계속 처리
    if (channel.length === 1) {
      return;
    }
  }

  eventLogger.log({
    eventName: name,
    channel,
    ...restParams,
    ablyOnlyLog: ably_only_log,
  });
  return;
};
